module.exports = __webpack_public_path__ + "images/mdj/members/message/outboxlist/outboxlist_icon02-639ca21d93a86ad60fe464f1816836b3.png";